export type WysiwygElement = {
  children: any
  element: any
  attributes: any
}

export const Element = ({
  attributes,
  children,
  element,
}: WysiwygElement): JSX.Element => {
  switch (element.type) {
    case 'heading-one':
      return <h1 {...attributes}>{children}</h1>
    case 'heading-two':
      return <h2 {...attributes}>{children}</h2>
    case 'heading-three':
      return <h3 {...attributes}>{children}</h3>
    case 'heading-four':
      return <h4 {...attributes}>{children}</h4>
    case 'heading-five':
      return <h5 {...attributes}>{children}</h5>
    case 'heading-six':
      return <h6 {...attributes}>{children}</h6>
    case 'block-quote':
      return <blockquote {...attributes}>{children}</blockquote>
    case 'bulleted-list':
      return <ul {...attributes}>{children}</ul>
    case 'list-item':
      return <li {...attributes}>{children}</li>
    case 'numbered-list':
      return <ol {...attributes}>{children}</ol>
    case 'link':
      return (
        <a href={element?.url} {...attributes}>
          {children}
        </a>
      )
    default:
      if (
        children.props.children.length === 1 &&
        (/^\s+$/.test(children.props.children[0]?.text) ||
          children.props.children[0]?.text === '')
      ) {
        return <br />
      }
      return <p {...attributes}>{children}</p>
  }
}
